module.exports = __webpack_public_path__ + "img/DashboardMobileApp3.7b265991.jpg";